<evc-modal
  id="evc-modal"
  [showReduceButton]="false"
  [showCloseButton]="isCompleted()"
  (closeModal)="onClose()"
>
  <ng-content modal-content>
    <div class="content">
      @if (!isCompleted()){
        <div class="modal-left">
          <div class="spinner"></div>
          <div class="main-label">{{ "migration.progress.title" | translate }}</div>
          <div class="secondary-label">{{ "migration.progress.subtitle" | translate }}</div>
        </div>
      }
      <app-assets-introduction />
    </div>
  </ng-content>
</evc-modal>
